import { useEffect } from "react";
import {
  useAreaGenerateStore,
  useCustomAlertStore,
  usePathStore,
} from "../../../../Store/store";
import { DeleteAreaMode, GetAreaModeId } from "../../../../api/potreeAPI";

/**
 * 영역 모드(카테고리) 목록 조회, 추가 모달, 삭제 API, 선택 시 색상 동기화
 * Pathgenerate 영역 모드 관련 로직만 분리
 */
export function useAreaMode() {
  const { showInfoAlert, showSuccessAlert } = useCustomAlertStore();
  const { areaModeIdList, setAreaModeIdList } = usePathStore();
  const {
    setIsAddAreaModeOpen,
    selectedAreaType,
    setSelectedAreaType,
    selectedAreaColor,
    setSelectedAreaColor,
  } = useAreaGenerateStore();

  useEffect(() => {
    const fetchAreaModeIdList = async () => {
      const response = await GetAreaModeId();
      setAreaModeIdList(response);
    };
    fetchAreaModeIdList();
  }, []);

  const openAddModal = () => {
    setIsAddAreaModeOpen(true);
  };

  const deleteSelectedMode = async () => {
    try {
      const response = await DeleteAreaMode(selectedAreaType);

      if (response.success) {
        showSuccessAlert("영역 모드 삭제 성공", "영역 모드를 삭제했습니다.");
      }
      const areaModeIdList = await GetAreaModeId();
      setAreaModeIdList(areaModeIdList);

      setSelectedAreaType(null);
      setSelectedAreaColor(null);
    } catch (error) {
      console.error("영역 모드 삭제 실패:", error);
      error.response.status === 403 &&
        showInfoAlert("영역 모드 삭제 실패", "기본 영역은 삭제할 수 없습니다.");
    }
  };

  // 선택된 영역 색상 업데이트
  useEffect(() => {
    if (!selectedAreaType || !Array.isArray(areaModeIdList)) return;

    const selected = areaModeIdList.find(
      (area) => area.id === selectedAreaType,
    );

    if (selected?.typeColor) {
      setSelectedAreaColor(selected.typeColor);
    }
  }, [selectedAreaType, areaModeIdList]);

  return {
    areaModeIdList,
    selectedAreaType,
    selectedAreaColor,
    setSelectedAreaType,
    openAddModal,
    deleteSelectedMode,
  };
}
